import React from "react";
import { useIntl } from "react-intl";
import LinkButton from "../../UI/Button/LinkButton";

import { faTrashAlt, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const AlertsItem = (props) => {
    const intl = useIntl();

    function TrashBtn(props){
        return (
            <button 
                className="btn btn-icon btn-sm float-right mr-1" 
                title="supprimer cette notifications..." 
                onClick={props.onClick}>
                    <FontAwesomeIcon icon={faTrashAlt} />
            </button>  
        );
    }

    function Badge(props){
        return (<span className="badge badge-new ml-1">New</span>);
    }

    return (
        <div className="list list-item pb-2">
            <div className="col-12 p-0">
                <div className="list-title">{props.title}
                    {props.status === "new" && <Badge />}
                    <TrashBtn onClick={props.onClick}/>
                </div>
                <div className="list-subtitle">{props.date}</div>
                <div className="list-text mt-1 mb-2">{props.message}</div>
                <div>
                    <LinkButton 
                        className="btn btn-link btn-link-pink"
                        icon={faArrowRight} 
                        label={intl.messages.seeMore}
                        to={props.to}
                    />
                </div>
            </div>
        </div>
    );
}

export default AlertsItem;